import Quotes from "../../images/testimonials/quotes.png";

function TestimonialBox({ text, name, job }) {
  return (
    <div className="flex flex-col text-left py-2 relative">
      <img alt="quote_img" src={Quotes} className="w-[40px] sm:w-[50px] mb-3 opacity-90" />
      <p className="text-[14px] sm:text-[16px] md:text-[17px] italic text-[#dedede] mb-6 leading-relaxed">
        {text}
      </p>
      <div>
        <h3 className="text-white text-[18px] sm:text-[22px] font-bold">{name}</h3>
        <p className="text-[12px] sm:text-[14px] font-medium text-yellow-400 mt-0.5">{job}</p>
      </div>
    </div>
  );
}

export default TestimonialBox;
